import { render, staticRenderFns } from "./ValueFromResource.vue?vue&type=template&id=47e6bc10&scoped=true&"
import script from "./ValueFromResource.vue?vue&type=script&lang=js&"
export * from "./ValueFromResource.vue?vue&type=script&lang=js&"
import style0 from "./ValueFromResource.vue?vue&type=style&index=0&id=47e6bc10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e6bc10",
  null
  
)

export default component.exports